import React from "react";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  containerClassName?: string;
  errortext?: string;
  helpertext?: string;
  rows?: number;
  startingAdornment?: React.ReactNode;
  endingAdornment?: React.ReactNode;
}

export function TextInput(props: TextInputProps) {
  const {
    startingAdornment,
    endingAdornment,
    containerClassName,
    ...inputProps
  } = props;
  const extraClasses = props.className ? props.className : "";

  const hasAdornment = !!startingAdornment || !!endingAdornment;

  return (
    <div className={containerClassName}>
      {props.label && (
        <label
          htmlFor={props.id}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {props.label}
        </label>
      )}
      {hasAdornment ? (
        <div
          className={`flex items-center bg-white h-11 rounded-md border-0 shadow-xs ring-gray-300 ring-1 ring-inset ${
            props.color === "error" ? "ring-error focus-within:ring-error" : ""
          } focus-within:ring-2 focus-within:ring-inset`}
        >
          {startingAdornment && (
            <div className="pl-3 pr-2 text-gray-500">{startingAdornment}</div>
          )}
          <input
            type="text"
            {...inputProps}
            className={`flex-1 bg-transparent w-full h-11 border-0 py-1.5 focus:ring-0 text-gray-900 disabled:text-gray-400 sm:text-sm sm:leading-6 ${
              startingAdornment ? "pr-2" : "px-2"
            } ${extraClasses}`}
          />
          {endingAdornment && (
            <div className="pl-2 pr-3 text-gray-500">{endingAdornment}</div>
          )}
        </div>
      ) : (
        <input
          type="text"
          {...inputProps}
          className={`px-2 block w-full bg-white h-11 rounded-md border-0 py-1.5 text-gray-900 disabled:text-gray-400 shadow-xs ring-gray-300 ring-1 ring-inset ${
            props.color === "error" ? "ring-error focus:ring-error" : ""
          } focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${extraClasses}`}
        />
      )}
      {props.errortext ? (
        <div className="mt-1 ml-1 text-error text-sm">{props.errortext}</div>
      ) : null}
      {props.helpertext ? (
        <div className="mt-1 ml-1 text-gray-600 text-sm">
          {props.helpertext}
        </div>
      ) : null}
    </div>
  );
}
